import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Step } from '../SurveyFormCard';
import classes from './Stepper.module.css';

type StepperProps = {
  steps: Step[];
  maxStep: number;
  onStepClick: (stepIndex: number) => void;
};

export const Stepper = ({ steps, maxStep, onStepClick }: StepperProps) => {
  const { t } = useTranslation();

  return (
    <nav aria-label={t('surveyCreation.stepper.ariaLabel')}>
      <ol className={classes.list}>
        {steps.map((step, index) => {
          const isCurrent = step.inProgress;
          const isDone = step.completed && !isCurrent;
          const isLocked = index > maxStep;

          return (
            <li
              key={step.id}
              className={cn(classes.item, {
                [classes.current]: isCurrent,
                [classes.done]: isDone,
                [classes.locked]: isLocked,
              })}
            >
              <span aria-hidden="true" className={classes.bar} />
              <button
                type="button"
                className={classes.button}
                onClick={() => onStepClick(index)}
                disabled={isLocked}
                aria-current={isCurrent ? 'step' : undefined}
              >
                <span aria-hidden="true" className={classes.dot}>
                  {isDone ? '✓' : step.stepNumber}
                </span>
                <span className={cn('ds-paragraph', classes.label)} data-size="sm">
                  {step.title}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
